// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__3yr4O","layout__main":"layout_layout__main__fBLBj"};